import apiService from '../apiService';

/**
 * 獲取會員統計
 * @returns {Promise} API 響應
 */
export const getUserStats = async () => {
    const url = '/api/admin/dashboard/user-stats';
    return apiService.GET(url);
};

/**
 * 獲取會員聘階分布統計
 * @returns {Promise} API 響應
 */
export const getRankDistribution = async () => {
    const url = '/api/admin/dashboard/rank-distribution';
    return apiService.GET(url);
};

/**
 * 獲取訂單統計
 * @returns {Promise} API 響應
 */
export const getOrderStats = async () => {
    const url = '/api/admin/dashboard/order-stats';
    return apiService.GET(url);
};

/**
 * 獲取取消申請統計
 * @returns {Promise} API 響應
 */
export const getCancellationStats = async () => {
    const url = '/api/admin/dashboard/cancellation-stats';
    return apiService.GET(url);
};

/**
 * 獲取熱銷商品統計
 * @param {Object} params - 查詢參數
 * @param {number} params.limit - 回傳筆數，預設 10
 * @param {number} params.days - 統計天數，預設 30
 * @returns {Promise} API 響應
 */
export const getTopSelling = async (params = {}) => {
    const url = '/api/admin/dashboard/top-selling';
    return apiService.GET(url, params);
};

/**
 * 獲取最近任務狀態需審核統計
 * @returns {Promise} API 響應
 */
export const getMissionReviewStats = async () => {
    const url = '/api/admin/dashboard/mission-review-stats';
    return apiService.GET(url);
};

/**
 * 獲取任務活動統計（階層式資料）
 * @returns {Promise} API 響應
 */
export const getMissionActivity = async () => {
    const url = '/api/admin/dashboard/mission-activity';
    return apiService.GET(url);
};
